import Api from '@/services/Api'

export default {
    GetDashboardBoxesSettings(environmentId) {
        return Api().get(`/admin/environments/${environmentId}/settings/dashboard/boxes`)
    },
    UpdateDashboardBoxesSettings(environmentId, boxes) {
        return Api().put(`/admin/environments/${environmentId}/settings/dashboard/boxes`, boxes)
    }
}
